import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetKyc = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_KYC
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetKycAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetKyc as SetGetKyc
}